export default {"src":"/_next/static/media/whatsapp-color-icon.51c4f3c6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};